import { SyntheticEvent, useCallback } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { imgHomeMenuPlayer } from "@/shared/assets/img";
import { Icon } from "@/shared/ui";

type Props = {
  id: number;
  isOnline: boolean;
  name: string;
  onClick?: (e: SyntheticEvent) => void;
  onMsg?: (() => void) | null;
  onCall?: (() => void) | null;
  onDismiss?: (() => void) | null;
};

export default function PersonalDataCard({
  id,
  isOnline,
  name,
  onClick,
  onCall,
  onMsg,
  onDismiss,
}: Props) {
  const { t } = useTranslation("business");

  const onCallHandler = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      onCall?.();
    },
    [onCall],
  );

  const onMsgHandler = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      onMsg?.();
    },
    [onMsg],
  );

  const onDismissHandler = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      onDismiss?.();
    },
    [onDismiss],
  );

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={onClick}
      className={clsx(
        "relative -left-0.5 flex items-center gap-2.5 h-14 p-2.5 transition-all bg-dark-800 rounded-2xl",
        onClick ? "cursor-pointer hover:bg-gray/20" : "",
      )}
    >
      <div
        className="relative size-[2.3125rem] rounded-tr-xl rounded-br-xl rounded-bl-xl"
        style={{
          backgroundImage: `url(${imgHomeMenuPlayer})`,
          backgroundSize: "100%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute -top-[0.1875rem] -left-[0.1875rem] flex justify-center items-center size-3 bg-dark-800 rounded-[0.75rem]">
          <div
            className={clsx(
              "size-[0.375rem] rounded-[0.375rem]",
              isOnline ? "bg-[#84FF97]" : "bg-[#636363]",
            )}
          />
        </div>
      </div>

      <div className="flex flex-col gap-0.5">
        <p className="text-inverted text-16 font-bold">{name}</p>
        <div className="flex items-center gap-2.5">
          <p className="text-12 font-bold text-white/50">sID: {id}</p>
          <span className="w-[1px] h-1.5 bg-white/10" />
          <p className="text-12 font-bold text-white/50">ТЕЛЕФОН: +7 777 777 77 77</p>
        </div>
      </div>
      <div className="flex items-center gap-1.5 ml-auto">
        {onCall && (
          <button
            type="button"
            className="group flex items-center justify-center size-8 bg-gray/20 rounded-xl transition-all hover:bg-gray/40"
            onClick={onCallHandler}
          >
            <Icon
              category="home-menu"
              name="phone"
              className="w-4 bg-inverted/70 group-hover:bg-inverted transition-all"
            />
          </button>
        )}
        {onMsg && (
          <button
            type="button"
            className="group flex items-center justify-center size-8 bg-gray/20 rounded-xl transition-all hover:bg-gray/40"
            onClick={onMsgHandler}
          >
            <Icon
              category="home-menu"
              name="mail"
              className="w-4 bg-inverted/70 group-hover:bg-inverted transition-all"
            />
          </button>
        )}
        {onDismiss && (
          <button
            type="button"
            className="group flex items-center justify-center h-8 py-3 px-4 text-11 font-bold uppercase rounded-xl transition-all bg-gray/20 hover:bg-gray/40"
            onClick={onDismissHandler}
          >
            {t("business.employees.dismiss")}
          </button>
        )}
      </div>
    </div>
  );
}
